<template>
  <div v-if="props.tipoServicio && props.idEmpresaServicios"
    class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <navegar-atras :ruta="ruta"></navegar-atras>
    <empresa-servicios-info :id-empresa-servicios="idEmpresaServicios" :tipo-servicio="tipoServicio"></empresa-servicios-info>
    <component :is="gestionTabComponent" :id-empresa-servicios="props.idEmpresaServicios" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import NavegarAtras from "@/components/NavegarAtras.vue";
import EmpresaServiciosInfo from "@/components/empresas-servicios/EmpresaServiciosInfo.vue";
import { getGestionTabComponent } from "@/components/empresas-servicios/ComponentFactory";

const props = defineProps({
  tipoServicio: String,
  idEmpresaServicios: String
});

const ruta = computed(() => `/empresas-servicios/${props.tipoServicio}`);

const gestionTabComponent = computed(() => {
  return getGestionTabComponent(props.tipoServicio || "");
});

</script>